import { Agency } from 'core';
import { ColumnDefinition, sortableColumn, SortDescriptor } from 'components/TableColumn/TableColumn';
import { TableChangeHandler } from 'react-bootstrap-table-next';
import { Pagination } from 'core/pagination/Pagination';

export interface AgencyListModel {

  readonly vendorNumberColumn: ColumnDefinition;
  readonly idColumn: ColumnDefinition;
  readonly nameColumn: ColumnDefinition;
  readonly currencyColumn: ColumnDefinition;
  readonly timeZoneColumn: ColumnDefinition;
  readonly loginTitleColumn: ColumnDefinition;
  readonly loginDomainColumn: ColumnDefinition;
  readonly editBtnsColumn: ColumnDefinition;

  readonly agencies: Array<Agency>;
  readonly pagination: Pagination;
  readonly onListChange?: TableChangeHandler<Agency>;
  readonly noDataDescription: string;
  readonly defaultSorts: SortDescriptor;
}

export type AgencyListProps = {

  readonly model: AgencyListModel;
};

export enum AgencyListColumns {
  AGENCY_ID = 'id',
  VENDOR_NUMBER = 'vendorNumber',
  LOGIN_TITLE = 'loginTitle',
  LOGIN_DOMAIN = 'loginDomain',
  TIME_ZONE = 'timeZone',
  CURRENCY = 'currency',
  EDITBTN = 'editBtn'
}

export class DefaultAgencyListModel implements AgencyListModel {
  agencies: Array<Agency>;
  pagination: Pagination;
  onListChange?: TableChangeHandler<Agency>;

  constructor (agencies: Array<Agency>, pagination: Pagination, onListChange?: TableChangeHandler<Agency>) {
    this.agencies = agencies;
    this.pagination = pagination;
    this.onListChange = onListChange;
  }

  get noDataDescription (): string {
    return 'agencies.noDataAvailable';
  }

  get vendorNumberColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.VENDOR_NUMBER, 'agencies.headers.vendorNumber');
  }

  get idColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.AGENCY_ID, 'agencies.headers.id');
  }

  get nameColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.AGENCY_ID, 'agencies.headers.name');
  }

  get loginTitleColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.LOGIN_TITLE, 'agencies.headers.loginTitle');
  }

  get loginDomainColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.LOGIN_DOMAIN, 'agencies.headers.loginDomain');
  }

  get timeZoneColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.TIME_ZONE, 'agencies.headers.timeZone');
  }

  get currencyColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.CURRENCY, 'agencies.headers.currency');
  }

  get editBtnsColumn (): ColumnDefinition {
    return sortableColumn(AgencyListColumns.EDITBTN, '', false);
  }

  get defaultSorts (): SortDescriptor {
    return [{
      dataField: AgencyListColumns.AGENCY_ID,
      order: 'asc'
    }];
  }
}
